import { MolsonBox } from '@components/reusable'
import { molsonStyled } from '@theme/customMuiExports'

export const ArchivedWrapper = molsonStyled(MolsonBox)(({ theme }) => ({
  '& .MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled ': {
    color: `${theme.palette.primary.error} !important`
  }
}))
